<template style="background-color: white;">
    <div style="background-color: white;">
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-card flat class="box" id="box">
                <v-row >
                <v-col cols="12" sm="3" md="3" justify="start" class="no-display" v-if="comp_value_earn">
                    <center>
                        <v-btn @click="print()" class="info"> <v-icon left color="black">mdi-printer</v-icon>Proceed to print</v-btn>                        
                    </center>                    
                </v-col>
                
                <!-- <v-col  align="end" class="no-display">
                    <center>
                        <v-btn @click="download()" class="info"> <v-icon left color="black">mdi-download</v-icon>Download</v-btn>                        
                    </center>                    
                </v-col> -->
                
                </v-row>
                
                <div v-if="org_basic_data" class="receipt-header">
                    <div v-if="org_basic_data.school_name == 'Zeal International School'">
                        <img src="https://eduplusschool.s3.ap-south-1.amazonaws.com/zeal/CBSE+LETTERHEAD.jpg" alt=""
                            width="100%" />
                    </div>
                    <v-row v-else align="center" no-gutters>
                
                        <!-- LEFT LOGO -->
                        <v-col cols="3" class="text-left">
                            <img v-if="org_basic_data.trust_logo" :src="org_basic_data.trust_logo" class="header-logo"
                                alt="Trust Logo" />
                        </v-col>
                
                        <!-- CENTER CONTENT -->
                        <v-col cols="6" class="text-center">
                
                            <!-- TRUST NAME -->
                            <div class="trust-name" v-if="org_basic_data.trust_name">
                                {{ org_basic_data.trust_name }}
                            </div>
                
                            <!-- SCHOOL NAME -->
                            <div class="school-name">
                                {{ org_basic_data.school_name }}
                            </div>
                
                            <!-- ADDRESS -->
                            <div class="header-text">
                                {{ org_basic_data.address }}
                            </div>
                
                            <!-- PHONE -->
                            <div class="header-text" v-if="org_basic_data.phone">
                                Phone : {{ org_basic_data.phone }}
                            </div>
                
                            <!-- EMAIL -->
                            <div class="header-text" v-if="org_basic_data.email">
                                Email : {{ org_basic_data.email }}
                            </div>
                
                            <!-- WEBSITE -->
                            <div class="header-text" v-if="org_basic_data.website">
                                Website : {{ org_basic_data.website }}
                            </div>
                
                        </v-col>
                
                        <!-- RIGHT LOGO -->
                        <v-col cols="3" class="text-right">
                            <img v-if="org_basic_data.school_logo" :src="org_basic_data.school_logo" class="header-logo"
                                alt="School Logo" />
                        </v-col>
                        <div class="header-divider"></div>
                
                    </v-row>               
                    
                </div>
                <div style="position: relative; height: 1050px;">
                <v-img v-if="tenant == 'uwws'"
                    src="https://universal-wws-schoolerp.s3.ap-south-1.amazonaws.com/logo/uwws_logo.png"
                    style="position: absolute; top: 12%; left: 20%; width: 60%; height: 60%; opacity: 0.1; z-index: 0; object-fit: contain;"
                ></v-img>
                <div class="row" v-if="comp_value_earn">
                    <v-col style="margin-left: 30%;" class="mt-0 pt-0" cols="12" sm="12" md="12">
                        <h3>Pay Slip For {{ salary_month }}</h3>
                    </v-col>
                    <v-col class="mt-0 pt-0" cols="12" sm="6" md="6"><strong>Emp. No. : {{ emp_code }}</strong></v-col>
                    <v-col class="mt-0 pt-0" cols="12" sm="6" md="6"><strong>Name : {{ emp_name }}</strong></v-col>
                    <!-- <v-col class="mt-0 pt-0 hr-line" cols="12" sm="12" md="12">
                        <hr />
                    </v-col> -->
                    <v-col class="mt-0 pt-0" cols="12" sm="6" md="6"><strong>Designation : {{ emp_designation }}</strong></v-col>
                    <v-col class="mt-0 pt-0" cols="12" sm="6" md="6"><strong>Date Of Joining : {{ date_of_joining }}</strong></v-col>
                    <!-- <v-col class="mt-0 pt-0 hr-line" cols="12" sm="12" md="12">
                        <hr />
                    </v-col> -->
                    <v-col class="mt-0 pt-0" cols="12" sm="6" md="6"><strong>P.F. No. : {{ emp_pf_no }}</strong></v-col>
                    <v-col class="mt-0 pt-0" cols="12" sm="6" md="6"><strong>UAN : {{ emp_uan_no }}</strong></v-col>
                    <!-- <v-col class="mt-0 pt-0 hr-line" cols="12" sm="12" md="12">
                        <hr />
                    </v-col> -->
                    <v-col class="mt-0 pt-0" cols="12" sm="6" md="6"><strong>Days Worked : {{ working_days }}</strong></v-col>
                    <v-col class="mt-0 pt-0" cols="12" sm="6" md="6"><strong>Account Number : {{ emp_bank_ac_no }}</strong></v-col>
                    <!-- <v-col class="mt-0 pt-0 hr-line" cols="12" sm="12" md="12">
                        <hr />
                    </v-col> -->
                    <v-row v-if="tenant == 'uwws'">
                        <v-col cols="12" sm="6" md="6" class="mt-0 pt-0"><b></b></v-col>
                        <v-col cols="12" sm="6" md="6" class="mt-0 pt-0"><b>PAN No. : {{ pan_no }}</b></v-col>
                    </v-row>
                    <v-col v-if="tenant != 'vvp'" cols="12" sm="12" md="12"><b>THIS SLIP IS NOT VALID FOR OBTAINING LOAN</b></v-col>
                    <v-col cols="12" sm="6" md="6">
                        <table>
                            <thead>
                                <tr>
                                    <th style="text-align: left;" class="pl-2">Earning</th>
                                    <th style="text-align: right;" class="pr-2">Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr style="border: none !important;" v-for="cn,index in comp_value_earn" :key="index">
                                    <span class="pl-2"> <strong>{{ cn.comp_name }}</strong> </span>
                                    <td style="text-align: right;" class="pr-2">{{ cn.comp_value }}.00</td>
                                </tr>
                                <tr v-if="comp_flag_earn" style="border: none !important;" v-for="index in this.comp_loop_value" :key="index">
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr >
                                    <td class="pl-2">Total Earning</td>
                                    <td style="text-align: right;" class="pr-2">{{ total_earn }}.00</td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" style="margin-left: -24px;">
                        <table>
                            <thead>
                                <tr>
                                    <th style="text-align: left;" class="pl-2">Deduction</th>
                                    <th style="text-align: right;" class="pr-2">Amount</th>
                                </tr>
                            </thead>
                            <tbody >
                                <tr  style="border: none !important;" v-for="cn,index in comp_value_dedu" :key="index">
                                    <td v-if="cn.comp_value>0" class="pl-2">{{cn.comp_name}}</td>
                                    <td v-if="cn.comp_value>0" style="text-align: right;" class="pr-2">{{cn.comp_value}}.00</td>
                                </tr>
                                <tr v-if="comp_flag_dedu" style="border: none !important;" v-for="index in this.comp_loop_value" :key="index">
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td class="pl-2">Total Deduction</td>
                                    <td style="text-align: right;" class="pr-2">{{ total_deduct }}.00</td>
                                </tr>
                                <tr>
                                    <td class="pl-2">Net Salary</td>
                                    <td style="text-align: right;" class="pr-2">{{ net_sal }}.00</td>
                                </tr>
                            </tbody>
                        </table>
                    </v-col>
                    <v-col class="mt-0 pt-0 pl-5" cols="12" sm="9" md="9">
                        <span><strong>Net salary in words Rs.: {{net_sal_words}}</strong></span>
                    </v-col>
                    <v-col class="mt-0 pt-0 pl-5" v-if="tenant == 'vvp'" cols="12" sm="12" md="12">
                        <span><strong>Please Note : This slip shall be considered valid for loan processing only upon authentication with an official signature and stamp, though the school will not be responsible for the recovery of any loan.</strong></span>
                    </v-col>
                    <!-- <v-col cols="12" sm="9" md="9"></v-col> -->
                     <v-row class="pr-9 pt-9" justify="end"><strong>Authorised Signature</strong></v-row>
                    <!-- <v-col class="mt-5 pt-5 pr-5" cols="12" sm="3" md="3" style="text-align: end;"><strong>Authorised Signature</strong></v-col> -->
                    <v-col class="mt-0 pt-0" cols="12" sm="12" md="12">
                        <hr />
                        <b v-if="tenant != 'vvp'" style="margin-left: 30%;"> Computer Generated Pay Slip Requires No Signature.</b>
                    </v-col>
                </div>
                </div>
            </v-card>
        </v-container>
    </div>
    <!-- /. root div -->
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import html2pdf from 'html2pdf.js'
    export default {
        data: () => ({
            loader: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            title: "",
            description: "",
            sal_month_list: [],
            sal_month: null,
            year: null,
            year_list: [],
            fmsg: null,
            emp: null,
            emp_code: null,
            emp_name: null,
            emp_type: null,
            emp_section: null,
            emp_designation: null,
            emp_pf_no: null,
            emp_bank_ac_no: null,
            emp_ifsc_code: null,
            emp_bank: null,
            net_sal_words: null,
            net_sal: null,
            working_days: null,
            total_earn: null,
            total_deduct: null,
            comp_value_earn: null,
            comp_value_dedu: null,
            salary_month: null,
            org_basic_data: null,
            date_of_joining: null,
            emp_uan_no: null,
            pan_no: null,
            tenant: null,
            comp_loop_value:null,
            comp_flag_dedu:false,
            comp_flag_earn:false,
            pay_slip_addr_line_1:null
        }),
        methods: {
            fetchSalarySlip() {
                const data = {
                    sal_month: this.sal_month,
                };
                this.loader = true;
                axios
                    .post("/Payroll/getMonthlySalarySlip", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.emp = res.data.emp;
                            this.emp_code = res.data.emp_code;
                            this.emp_name = res.data.emp_name;
                            this.emp_type = res.data.emp_type;
                            this.emp_section = res.data.emp_section;
                            this.emp_designation = res.data.emp_designation;
                            this.emp_pf_no = res.data.emp_pf_no;
                            this.emp_bank_ac_no = res.data.emp_bank_ac_no;
                            this.emp_ifsc_code = res.data.emp_ifsc_code;
                            this.emp_bank = res.data.emp_bank;
                            this.net_sal_words = res.data.net_sal_words;
                            this.net_sal = res.data.net_sal;
                            this.working_days = res.data.working_days;
                            this.total_earn = res.data.total_earn;
                            this.total_deduct = res.data.total_deduct;
                            this.comp_value_earn = res.data.comp_value_earn.filter(item => item.comp_value > 0);
                            this.comp_value_dedu = res.data.comp_value_dedu.filter(item => item.comp_value > 0);
                            this.pay_slip_addr_line_1 = res.data.pay_slip_addr_line_1;
                            if(this.comp_value_earn.length > this.comp_value_dedu.length)
                            {
                                this.comp_loop_value = this.comp_value_earn.length - this.comp_value_dedu.length
                                this.comp_flag_dedu = true
                            }
                            else{
                                this.comp_loop_value = this.comp_value_dedu.length - this.comp_value_earn.length
                                this.comp_flag_earn = true
                            }
                            //alert(this.comp_loop_value)
                            this.salary_month = res.data.sal_month;
                            this.date_of_joining = res.data.date_of_joining;
                            this.emp_uan_no = res.data.emp_uan_no;
                            this.pan_no = res.data.pan_no;
                            this.org_basic_data = res.data.org_basic_data;
                            this.loader = false;
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                            this.loader = false;
                            return;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                            this.loader = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                        this.loader = false;
                    })
                    .finally(() => {});
            },
            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
            download(){
                // const img = document.getElementById('myImage');
                // img.onload = () => {
                const componentsToHide = document.querySelectorAll('.no-display');
                componentsToHide.forEach(component => {
                    component.style.display = 'none';
                });
                const element = document.getElementById("box");
                
                const opt = {
                    // margin : 0,
                    filename : 'pay_slip.pdf',
                    image: { type: 'png', quality: 0.98},
                    jsPDF:  { unit: 'in', format: 'A4', orientation: 'portrait' },
                    
                };
                html2pdf().from(element).set(opt).save();
            // }
                },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
        mounted() {
            this.sal_month = localStorage.getItem("sal_month");
            this.fetchSalarySlip()
            this.tenant = localStorage.getItem("EPS-tenant");
        },
        watch: {},
    };
</script>
<style scoped>
    /* .v-text-field{
      width: 80px;
} */
    hr {
        width: 100%;
        color: gray;
    }
    thead {
        font-weight: bold !important;
    }
    th,
    td {
        font-weight: bold !important;
    }
    tr,
    td,
    th {
        border-collapse: collapse;
        border-left: 1px solid black;
        height: 40px;
    }
    tr,
    tbody {
        border-bottom: 1px solid black;
        border-collapse: collapse;
        border: 1px solid black;
    }
    #align-left {
        text-align: center;
        } 
    #align-right{
        text-align: center;
    }
    
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
        }
        td + td,
        th + th {
            width: auto;
        }
    }
    table {
        white-space: nowrap !important;
        border-collapse: collapse;
        width: 100%;
    }

    @media print {
        @page {
            /* size: A4 !important;
            margin-top: none !important;
            padding-top: none !important;
            background-color: white !important; */
            size:A4;
            margin:0;
        }
        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }
        hr{
            display: none;
        }
       
        .box{
            border: none !important;
            
        }
        .print-section{
            page-break-inside: avoid;
            break-inside: avoid;
        }

        .receipt-header{
            page-break-after: avoid;
        }
    }
    .stud_details2 {
        border-bottom: 2px solid black;
        font-family: "Times New Roman";
        height: 25px;
    }
    .receipt-header {
  width: 100%;
  padding: 8px 0;
}

.header-logo {
  max-height: 150px;
  max-width: 250px;
}

.trust-name {
  font-size: 25px;
  font-weight: 600;
}

.school-name {
  font-size: 20px;
  font-weight: 700;
  margin: 2px 0;
}

.header-text {
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
}

.header-divider {
  width: 100%;
  border-bottom: 2px solid #000;
  margin-top: 10px;
}


</style>
